import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from '@wfp-common/hooks/useNavigate';

import { hasFeatureAccess } from '../../../login/auth';
import { ManagerPermission } from '../../../permission-profiles/permission';

export function useLocationsUtils() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const auth = useSelector((state: any) => state.auth);
    const locations = useSelector((state: any) => state.locations.list);

    useEffect(() => {
        const hasAccess = hasFeatureAccess(auth, ManagerPermission.beneficiariesRead);
        if (!hasAccess) {
            navigate('/');
        } else {
            // Dispatch the load locations action - adjust this to match your actual action creator
            dispatch({ type: 'LOAD_LOCATIONS' });
        }
    }, [auth, dispatch, navigate]);

    const cancel = useCallback(
        (locationId: number) => (): void => {
            // Adjust this to match your actual action creator
            dispatch({ type: 'CANCEL_LOCATION', payload: locationId });
        },
        [dispatch]
    );

    const authorize = useCallback(
        (locationId: number) => (): void => {
            // Adjust this to match your actual action creator
            dispatch({ type: 'AUTHORIZE_LOCATION', payload: locationId });
        },
        [dispatch]
    );

    return {
        actions: {
            cancel,
            authorize,
        },
        auth,
        locations,
        path: location.pathname,
        hasManager: !!auth.manager,
    };
}
